module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      spotify: true, 'is-selected': _vm.loadedSongs
    }
  }, [_c('div', {
    staticClass: "spotify__container"
  }, [_c('div', {
    staticClass: "spotify__text"
  }, [_c('h3', [_vm._v("Awesome " + _vm._s(_vm.userInfo.display_name) + ", "), _c('br'), _vm._v(" now select the playlist you want to export")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlaylist),
      expression: "selectedPlaylist"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        _vm.selectedPlaylist = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.searchSongs]
    }
  }, [(_vm.playlists.length == 0) ? _c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "value": "0"
    }
  }, [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "value": "0"
    }
  }, [_vm._v("Select your playlist")]), _vm._v(" "), _vm._l((_vm.playlists), function(playlist) {
    return _c('option', {
      domProps: {
        "value": {
          id: playlist.id,
          owner: playlist.owner.id,
          name: playlist.name
        }
      }
    }, [_vm._v(_vm._s(playlist.name))])
  })], 2)])])]), _vm._v(" "), _c('youtube', {
    attrs: {
      "songs": _vm.songs,
      "title": _vm.playlistTitle,
      "search": _vm.search
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9552a76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Spotify.vue
// module id = 53
// module chunks = 0